"use client";
import React, { useState } from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { title } from "@/styles/globalStyleVars";

export default function TaxCalculator() {
  // select category
  const categoryList = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female/ Senior Citizen" },
    { value: "third-gender", label: "Third Gender" },
    { value: "disabled", label: "Person with Disability" },
    { value: "freedom-fighter", label: "Gazetted Freedom Fighter" },
  ];

  // all state
  // input
  const [income, setIncome] = useState(1000000);
  const [taxRebate, setTaxRebate] = useState(0);
  const [category, setCategory] = useState(350000);
  // result
  const [tax, setTax] = useState(0);
  const [rebate, setRebate] = useState(0);

  // total income input
  const handleIncome = (e) => {
    setIncome(e);
  };

  // handle tax rebate
  const handleTaxRebate = (e) => {
    setTaxRebate(e);
  };

  // select category
  const handleCat = (e) => {
    if (e === "male") {
      setCategory(350000);
    }
    if (e === "female") {
      setCategory(400000);
    }
    if (e === "third-gender" || e === "disabled") {
      setCategory(475000);
    }
    if (e === "freedom-fighter") {
      setCategory(500000);
    }
  };

  // tax calculation
  React.useEffect(() => {
    const taxableIncome = income - category;

    let slab = 0;
    let nextSlab = true;
    if (taxableIncome > 0) {
      // 1st slab
      if (taxableIncome >= 100000) {
        setTax(5000);
        slab = taxableIncome - 100000;
      } else if (taxableIncome < 100000) {
        if ((taxableIncome * 5) / 100 > 5000) {
          setTax(taxableIncome * 5) / 100;
        } else {
          setTax(5000);
        }
      }

      // 2nd slab
      if (nextSlab && slab <= 300000) {
        setTax((t) => t + (slab * 10) / 100);
        nextSlab = false;
      } else if (nextSlab && slab > 300000) {
        setTax((t) => t + 30000);
        slab = slab - 300000;
      }

      // 3rd slab
      if (nextSlab && slab <= 400000) {
        setTax((t) => t + (slab * 15) / 100);

        nextSlab = false;
      } else if (nextSlab && slab > 400000) {
        setTax((t) => t + 60000);
        slab = slab - 400000;
      }

      // 4th slab
      if (nextSlab && slab <= 500000) {
        setTax((t) => t + (slab * 20) / 100);
        nextSlab = false;
      } else if (nextSlab && slab > 500000) {
        setTax((t) => t + 100000);
        slab = slab - 500000;
      }

      // 5th slab
      if (nextSlab && slab > 0) {
        setTax((t) => t + (slab * 25) / 100);
      }
    } else {
      setTax(0);
    }
  }, [income, category]);

  // tax rebate calculator
  React.useEffect(() => {
    if (taxRebate > 0) {
      setRebate((taxRebate * 15) / 100);
    }
  }, [taxRebate]);

  return (
    <StyledComponent className={"tax-calculator"}>
      <Container>
        <Row>
          <Col lg={6} className="cal-input">
            <h4>Select Category</h4>
            <Select
              onChange={(e) => handleCat(e.value)}
              placeholder={"Male"}
              styles={{
                dropdownIndicator: (provided, state) => ({
                  ...provided,
                  transform: state.selectProps.menuIsOpen && "rotate(180deg)",
                }),
              }}
              classNamePrefix={"react-select"}
              isSearchable={false}
              options={categoryList} // replace with your dropdown options
              theme={(theme) => ({
                ...theme,
                borderRadius: 0,
                colors: {
                  ...theme.colors,
                  primary25: "#e9e9e9",
                  primary: "black",
                },
              })}
            />

            <div className="cal-input__num">
              <div className="group">
                <h4>Total Taxable Income</h4>
                <input
                  value={income}
                  onChange={(e) => handleIncome(e.target.value)}
                  type="number"
                />
              </div>

              {/* {tax > 0 && ( */}
              <div className="group">
                <h4>Stock Market Investment</h4>
                <input
                  disabled={tax > 0 ? false : true}
                  value={taxRebate}
                  onChange={(e) => handleTaxRebate(e.target.value)}
                  type="number"
                />
                <p>{tax > 0 ? "" : "You are not eligible for Tax Rebate"}</p>
              </div>
              {/* )} */}
            </div>
          </Col>

          <Col lg={6}>
            {/* <p>{slab}</p> */}
            <div className="cal-output">
              <div className="cal-output__group">
                <h4>
                  Gross Payable Tax <br /> <span>(without Investment)</span>
                </h4>
                <h3>
                  {tax < 0
                    ? 0
                    : tax.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })}
                </h3>
              </div>
              <div className="cal-output__group">
                <h4>
                  Tax Rebate <br /> <span>(15% of the investment)</span> <br />
                </h4>
                <h3>
                  {" "}
                  {tax > 0 && rebate > 0
                    ? rebate.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })
                    : 0}
                </h3>
              </div>
              <div className="cal-output__group">
                <h4>Net Payable Tax</h4>
                <h3>
                  {tax > 0
                    ? tax - rebate > 5000
                      ? (tax - rebate).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                        })
                      : (5000).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                        })
                    : 0}
                </h3>
              </div>
            </div>

            {/* <h2>
              Gross Payable Tax <span>(without Investment)</span> <br />
              {tax < 0
                ? 0
                : tax.toLocaleString(undefined, { maximumFractionDigits: 2 })}
              <br />
            </h2>
            <br />
            <h2>
              Tax Rebate <span>(15% of the investment)</span> <br />
              {tax > 0 && rebate > 0
                ? rebate.toLocaleString(undefined, { maximumFractionDigits: 2 })
                : 0}
            </h2>
            <br />
            <h2>
              Net Payable Tax <br />{" "}
              {tax > 0
                ? tax - rebate > 5000
                  ? (tax - rebate).toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })
                  : (5000).toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })
                : 0}
            </h2> */}
          </Col>
        </Row>
      </Container>
    </StyledComponent>
  );
}

const StyledComponent = styled.section`
  min-height: 100vh;
  padding-top: 200px;
  padding-bottom: 200px;
  .cal-input {
    h4 {
      font-size: 24px;
      margin-bottom: 10px;
      line-height: 24px;
      font-family: ${title};
      font-weight: 600;
    }
    input[type="number"] {
      width: 100%;
      height: 40px;
      outline: none;
      padding: 0 10px;
      border: 1px solid rgb(198, 198, 198);
    }
    &__num {
      margin-top: 40px;
      .group {
        margin-bottom: 30px;
      }
    }
  }

  .col-lg-6 {
    &:nth-child(odd) {
      padding-right: 80px;
    }
    &:nth-child(even) {
      padding-left: 80px;
    }
  }

  .react-select__menu {
    background: white !important;

    li {
      font-size: 14px !important;
      line-height: 20px !important;
      font-weight: 400 !important;
    }

    a {
      font-size: 14px !important;
      line-height: 20px !important;
      font-weight: 400 !important;
    }
  }

  .react-select__indicator {
    padding: 0;
  }

  .react-select__placeholder {
    margin: 0;
    padding: 0;
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 20px !important;
    color: #191919 !important;
  }

  .react-select__control {
    border-bottom: 1px solid rgba(60, 60, 59, 0.5);
    margin-bottom: 0px;
    border-right: none;
    border-left: none;
    border-top: none;
    outline: none;
    box-shadow: none;
    padding-left: 0;
    padding-right: 0;
    cursor: pointer;

    .react-select__indicator-separator {
      display: none;
    }

    .react-select__input-container {
      padding: 0;
      margin: 0;
    }

    .react-select__single-value {
      margin: 0;
      padding: 0;
      font-size: 16px;
      /* font-weight: 500; */
      color: #3c3c3b;
      cursor: pointer !important;
    }

    .react-select__value-container {
      padding-left: 0;
      padding-right: 0;
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  .react-select__menu div {
    cursor: pointer !important;
  }
  .css-1xc3v61-indicatorContainer {
    color: hsl(0deg 1.99% 36.16%);
  }

  .cal-output {
    &__group {
      background-color: #191919;
      padding: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      h4 {
        font-size: 16px;
        line-height: 16px;
        color: #fff;
        span {
          color: #ffffff9e;
          font-size: 12px;
          line-height: 12px;
        }
      }
      h3 {
        color: #fff;
        font-size: 32px;
        line-height: 36px;
        font-weight: 500;
      }
    }
  }

  .group {
    p {
      margin-top: 2px;
    }
  }

  @media (max-width: 1200px) {
    .col-lg-6 {
      padding: 0 15px !important;
    }
  }

  @media (max-width: 991px) {
    padding-top: 150px;
    padding-bottom: 150px;
    .col-lg-6 {
      padding: 0 15px !important;
    }
  }

  @media (max-width: 600px) {
    br {
      display: none;
    }
    .cal-output__group {
      flex-wrap: wrap;
      h4 {
        min-width: 100%;
        margin-bottom: 20px;
      }
    }
  }
`;
